import Joi from 'joi';

export const schema = Joi.object({
  paymentMethod: Joi.string(),
});

export const schemaDebit = Joi.object({
  paymentMethod: Joi.string().error(new Error('Método de pago es necesario')),
  bankOption: Joi.string().error(new Error('Banco requerido')),
  accountNumber: Joi.string()
    .min(3)
    .error(new Error('Número de cuenta es requerido')),
  accountAddress: Joi.string()
    .min(3)
    .error(new Error('Dirección es requerida')),
});
